<template>
  <div class="memberCenter_wrap ChangeInform" :style="{ height: height }">
    <div class="nav_pos mb_nav_pos">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <router-link to="/MemberCenter">首页</router-link>
        </el-breadcrumb-item>
        <el-breadcrumb-item>合同详细</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="change_inform">
      <div class="title">基本信息</div>
      <div>
        <el-form :inline="true" :model="contract" class="form_table form_table1" ref="form" :inline-message="true">
          <el-form-item label="甲方名称"
            ><span>{{ contract.CompanyName }}</span></el-form-item
          >
          <el-form-item label="甲方联系人"
            ><span>{{ contract.PartyAName }}</span></el-form-item
          >
          <el-form-item label="甲方联系人联系方式"
            ><span>{{ contract.PartyATel }}</span></el-form-item
          >

          <el-form-item label="合同编号"
            ><span>{{ contract.ContractNumber }}</span></el-form-item
          >
          <el-form-item label="合同货期起算方式"
            ><span>{{ contract.TranslateType }}</span></el-form-item
          >
          <el-form-item label="合同起算时间"
            ><span>{{ contract.AuditDate }}</span></el-form-item
          >

          <el-form-item label="合同总价（元）"
            ><span>{{ contract.ContractFee }}</span></el-form-item
          >
          <el-form-item label="发货前联系人"
            ><span>{{ contract.ShippingContact }}</span></el-form-item
          >
          <el-form-item label="发货前联系人联系方式"
            ><span>{{ contract.ShippingTel }}</span></el-form-item
          >
          <el-form-item label="合同回签附件" class="all_line">
            <div v-for="(item1, index1) in contract.ContractAttachList" :key="index1">
              <el-link class="fileName" @click="fnDownload(item1.fileId)" :underline="false"> {{ item1.name }}</el-link>
              <el-link @click="fnReadPdf(item1.fileId)" :underline="false" style="color: #0361b1; padding-left: 15px"> 预览</el-link>
            </div>
          </el-form-item>
          <el-form-item label="补充合同回签附件" class="all_line">
            <div v-for="(item1, index1) in contract.AdjustmentSignBackFile" :key="index1">
              <el-link class="fileName" @click="fnDownload(item1.fileId)" :underline="false"> {{ item1.name }}</el-link>
              <el-link @click="fnReadPdf(item1.fileId)" :underline="false" style="color: #0361b1; padding-left: 15px"> 预览</el-link>
            </div>
          </el-form-item>
          <el-form-item label="终止合同回签附件" class="all_line">
            <div v-for="(item1, index1) in contract.TerminationSignBackFile" :key="index1">
              <el-link class="fileName" @click="fnDownload(item1.fileId)" :underline="false"> {{ item1.name }}</el-link>
              <el-link @click="fnReadPdf(item1.fileId)" :underline="false" style="color: #0361b1; padding-left: 15px"> 预览</el-link>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="title">设备概况</div>
      <el-table :data="projectList" class="table_wrap1">
        <el-table-column width="120px" label="货物名称" prop="InstrumentName" align="center"></el-table-column>
        <el-table-column width="120px" label="规格型号" prop="Specification" align="center"></el-table-column>
        <el-table-column width="120px" label="品牌" prop="Trademark" align="center"></el-table-column>
        <el-table-column width="80px" label="数量" prop="Count" align="center"></el-table-column>
        <el-table-column width="120px" label="总价" prop="SumFee" align="center"></el-table-column>
        <el-table-column width="100px" label="货期（自然日）" prop="DeliveryTerm" align="center"></el-table-column>
        <el-table-column width="120px" label="合同约定到货日期" prop="ArrivalDate" align="center"></el-table-column>
        <el-table-column width="250px" label="实际到货日期" prop="ActualArrivalDate" align="center"></el-table-column>
        <el-table-column width="120px" label="是否逾期" prop="IsOverTime" align="center"></el-table-column>
        <el-table-column width="250px" label="预警到货天数（自然日）" prop="WarnDay" align="center"></el-table-column>
        <el-table-column width="250px" label="提前到货天数（自然日）" prop="WarnDay1" align="center"></el-table-column>
        <el-table-column width="200px" label="实际设备到货地" prop="ArrivalAddressName" align="center"></el-table-column>
        <el-table-column width="120px" label="到货确认状态" prop="ArrivalConfirmState" align="center"></el-table-column>
        <el-table-column width="120px" label="验收状态" prop="AcceptanceState" align="center"></el-table-column>
        <el-table-column width="350px" label="到货确认函附件" prop="ConfirmAttach" align="center">
          <template slot-scope="sc">
            <div v-for="(item1, index1) in sc.row.ConfirmAttach" :key="index1">
              <el-link class="fileName" @click="fnDownload(item1.fileId)" :underline="false"> {{ item1.name }}</el-link>
              <el-link @click="fnReadPdf(item1.fileId)" :underline="false" style="color: #0361b1; padding-left: 15px"> 预览</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="350px" label="其他附件" prop="ConfirmOtherAttach" align="center">
          <template slot-scope="sc">
            <div v-for="(item1, index1) in sc.row.ConfirmOtherAttach" :key="index1">
              <el-link class="fileName" @click="fnDownload(item1.fileId)" :underline="false"> {{ item1.name }}</el-link>
              <el-link @click="fnReadPdf(item1.fileId)" :underline="false" style="color: #0361b1; padding-left: 15px"> 预览</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="title">发票信息</div>
      <el-table :data="fileInvoiceData" class="table_wrap1">
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column label="发票类型" prop="InvoiceTypeName" align="center"></el-table-column>
        <el-table-column label="开票日期" prop="InvoiceDate" align="center"></el-table-column>
        <el-table-column label="开票金额" prop="InvoiceAmount1" align="center"></el-table-column>
        <el-table-column label="寄件日期" prop="SendingDate" align="center"></el-table-column>
        <el-table-column label="发票快递单号" prop="ExpressNumber" align="center"></el-table-column>
        <el-table-column label="上传发票" prop="InvoiceAttach" align="center">
          <template slot-scope="sc">
            <div v-for="(item1, index1) in sc.row.InvoiceAttach" :key="index1">
              <el-link class="fileName" @click="fnDownload(item1.fileId)" :underline="false"> {{ item1.name }}</el-link>
              <el-link @click="fnReadPdf(item1.fileId)" :underline="false" style="color: #0361b1; padding-left: 15px"> 预览</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contractId: this.$route.query.contractId,
      contract: {},
      instrumentList: [],
      projectList: [],
      invoiceList: [],
      height: '0px'
    }
  },
  mounted() {
    let change_inform = document.getElementsByClassName('MemberHeader')[0]
    this.height = window.innerHeight - change_inform.clientHeight - 17 + 'px'
    this.getData()
    this.getArrivalConfirmData()
  },
  methods: {
    getData() {
      let config = {
        params: {
          contractId: this.contractId,
          invoiceId: this.invoiceId,
          isDetail: true
        }
      }
      this.getRequest('/Contract/GetInvioiceData', config).then((res) => {
        if (res.data.errcode == 0) {
          this.invoiceData = res.data.invoiceData
          this.invoiceTypeList = res.data.invoiceTypeList
          this.fileInvoiceData = res.data.fileInvoiceData
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },
    getArrivalConfirmData() {
      let config = {
        params: {
          contractId: this.contractId
        }
      }
      this.getRequest('/Contract/GetArrivalConfirmData', config).then((res) => {
        if (res.data.errcode == 0) {
          this.contract = res.data.contract
          this.projectList = res.data.projectList
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },
    fnReadPdf(fileId) {
      let routerData = this.$router.resolve({
        path: 'ReadPDF',
        query: {
          fileId: fileId
        }
      })
      window.open(routerData.href, '_blank')
    },
    fnDownload(fileId) {
      let token = window.localStorage.getItem('loginToken')
      var url = '/Common/DownloadFile?FileId=' + fileId + '&token=' + token + '&FileName='
      this.downloadfile(this.baseURL + url)
    }
  }
}
</script>

<style lang="scss" scoped>
.content_wrap {
  padding-bottom: 20px;
  margin-bottom: 20px;
}

.changeInform_btn_wrap {
  width: 366px;
  margin: 40px auto 0;

  .btn_1 {
    background: #055ba9;
    color: #fff;
    border: none;
  }
}

.supplierType {
  .el-form-item {
    display: inline-block;
    flex: 0 0 200px;

    .el-input {
      width: 200px;
    }
  }

  .supplierOtherType {
    ::v-deep.el-form-item__content {
      border-bottom: none;
    }
  }
}

::v-deep.businessTermDate {
  .el-form-item__content {
    align-items: center;
  }

  .term {
    margin-top: 0 !important;
    margin-left: 0 !important;
  }

  .el-input {
    width: 300px;
    margin-right: 8px;
  }

  .businessTermEndDate {
    margin-bottom: 0 !important;

    .el-input {
      width: 100% !important;
    }

    .el-form-item__label:before {
      display: none;
    }

    .el-form-item__content {
      border-bottom: none;
    }
  }
}

::v-deep.el-form-item {
  .el-input.is-disabled .el-input__inner,
  .el-select .el-input.is-disabled .el-input__inner,
  .el-checkbox__input.is-disabled + span.el-checkbox__label,
  .el-textarea.is-disabled .el-textarea__inner {
    color: #606266;
  }
}

.back_btn {
  height: 26px;
  bottom: 7px;
  padding: 0 18px;
  border-radius: 14px;
}

.businessTermDate1 ::v-deep.el-input__inner {
  min-width: 150px !important;
}

.tableWrap5_custom ::v-deep.btn_wrap {
  margin-right: 12px;
  margin-top: 15px;
}

.tableWrap5_custom ::v-deep.tab_wrap5 {
  margin: 0 15px 15px;

  .product_form {
    margin-bottom: 0;
  }
}

.change_inform ::v-deep.icon_tips2 {
  vertical-align: middle !important;
}

.rangeDate ::v-deep.el-form-item__content {
  .el-input__inner,
  .el-range-editor {
    width: 300px;
    margin-right: 8px;
    text-align: center;

    .el-range-input {
      font-size: 14px;
    }
  }
}

.tree ::v-deep .el-tree-node {
  .el-tree-node__children {
    white-space: normal;

    .el-tree-node {
      display: inline-block;
    }
  }
}

.otherinput {
  height: 25px;
  line-height: 40px;
  width: 100%;
}

.width_full {
  width: 100% !important;
}

.statistics_table {
  width: 98.5%;
  table-layout: fixed;

  th {
    padding: 6px 0;
    text-align: center !important;
    background: #d8eafa !important;
    color: #046663;
    font-weight: normal !important;
    border: 1px solid #95c7f0;
    vertical-align: middle;
    white-space: nowrap;
  }

  td {
    padding: 6px 12px;
    border: 1px solid #95c7f0;
    background: #fff !important;
    text-align: center;
  }

  tr {
    border-bottom: 1px solid #95c7f0;
  }
}

.file_wrap {
  width: 18rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.form_table1 {
  .el-form-item {
    flex: 33.3%;
  }
}
</style>